import { render } from "./Gesiap.vue?vue&type=template&id=297147dd"
import script from "./Gesiap.vue?vue&type=script&lang=js"
export * from "./Gesiap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__